import { useEffect, useMemo, useRef } from "react";

/**
 * BookingCalendar, GHL scheduling widget embedded via <iframe>.
 *
 * Mounts the GHL `form_embed.js` script once so the iframe self-resizes as
 * the user picks a slot.
 *
 * Prefill: GHL Calendar widgets accept the following query params which are
 * used to pre-populate the "Your details" form shown after the user picks a
 * slot. Fields the user does not need to retype: first_name, last_name,
 * email, phone. Company is passed too (some widget flavours read it, others
 * ignore it, harmless if unknown).
 */
const IFRAME_BASE =
  "https://link.venditoreadistanza.com/widget/booking/bd9loBIxDsMVdZwHYJlQ";
const EMBED_SCRIPT_SRC =
  "https://link.venditoreadistanza.com/js/form_embed.js";

function buildIframeSrc(prefill) {
  if (!prefill) return IFRAME_BASE;
  const params = new URLSearchParams();
  if (prefill.first_name) params.set("first_name", prefill.first_name);
  if (prefill.last_name) params.set("last_name", prefill.last_name);
  if (prefill.email) params.set("email", prefill.email);
  if (prefill.phone) params.set("phone", prefill.phone);
  if (prefill.company) params.set("company", prefill.company);
  const qs = params.toString();
  return qs ? `${IFRAME_BASE}?${qs}` : IFRAME_BASE;
}

export default function BookingCalendar({ id, className = "", prefill }) {
  const iframeId = useRef(
    id || `booking-${Math.random().toString(36).slice(2, 10)}`
  );

  const src = useMemo(() => buildIframeSrc(prefill), [prefill]);

  useEffect(() => {
    if (
      typeof document === "undefined" ||
      document.querySelector(`script[src="${EMBED_SCRIPT_SRC}"]`)
    ) {
      return;
    }
    const s = document.createElement("script");
    s.src = EMBED_SCRIPT_SRC;
    s.type = "text/javascript";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <iframe
      id={iframeId.current}
      src={src}
      title="Prenota un appuntamento con Lovac"
      className={className}
      style={{ width: "100%", border: "none", overflow: "hidden", minHeight: 720 }}
      scrolling="no"
      data-testid="booking-calendar-iframe"
    />
  );
}
